module.exports = __webpack_public_path__ + "craftworkgrotesk-regular-webfont.334f2bf875a46054e253.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/grotesc/craftworkgrotesk-regular-webfont.woff2
// module id = ./src/assets/webfonts/grotesc/craftworkgrotesk-regular-webfont.woff2
// module chunks = styles